import template from './item_type.create.html';
import controller from './item_type.create.controller';
import './item_type.create.scss';

let itemTypeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default itemTypeCreateComponent;



// WEBPACK FOOTER //
// ./client/app/components/item_type/create/item_type.create.component.js